import type { ReviewFieldName } from './schema';

/** Spanish label for each of the 8 fields recognition and review share
 * (`backend/app/domain/enums.py`'s `FieldName`). */
export const FIELD_NAME_LABELS: Readonly<Record<ReviewFieldName, string>> = {
  customer: 'Cliente',
  date: 'Fecha',
  // The label printed on the pad itself, so the owner is looking for the same word on paper
  // that the screen shows them.
  folio: 'Folio',
  product: 'Concepto',
  quantity: 'Cantidad',
  unit_price: 'Precio unitario',
  line_amount: 'Importe',
  note_total: 'Total escrito',
};

/** Line-level fields, matching `backend/app/domain/enums.py`'s `LINE_LEVEL_FIELDS` - used to
 * decide which field names an annotation on a row may point at. */
export const LINE_LEVEL_FIELD_NAMES: readonly ReviewFieldName[] = [
  'product',
  'quantity',
  'unit_price',
  'line_amount',
];

/** Note-level fields, matching `backend/app/domain/enums.py`'s `NOTE_LEVEL_FIELDS`. */
export const NOTE_LEVEL_FIELD_NAMES: readonly ReviewFieldName[] = [
  'customer',
  'date',
  'folio',
  'note_total',
];
